<template>
    <div style="height: 100%">
      <div style="display: flex; width: 100%">
        <div style="width: 90%; height: 40px">
          <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
            <el-input v-model="formDatas.appcName" style="width: 140px;" size="small" placeholder="请输入名称"
              clearable></el-input>
            <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
              v-if="post == 2" style="width: 130px">
              <el-option label="已删除" :value="2" key="2"></el-option>
              <el-option label="未删除" :value="1" key="1"></el-option>
            </el-select>
            <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
              style="margin-left: 10px">搜索</el-button>
            <el-button type="danger" size="small" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button>
          </el-row>
        </div>
        <div style="width: 10%; height: 40px">
          <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
            <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增支付渠道</el-button>
  
            <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
          </el-row>
        </div>
      </div>
      <div class="tablemain">
        <div class="tablecss">
          <div style="width: 100%">
            <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
              :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
              :checkbox-option="checkboxOption" row-key-field-name="appcId" :cellSelectionOption="cellSelectionOption"
              style="width: 100%" :editOption="editOption" />
            <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
          </div>
          <div class="table-pagination">
            <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
              :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
              @on-page-size-change="pageSizeChange" />
          </div>
        </div>
        <!-- 新增 -->
        <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑支付渠道' : '新增支付渠道'" :before-close="handleClose"
          :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
          <div class="demo-drawer__content" style="height: 90%;">
            <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
              <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                <el-form-item label="支付渠道" prop="appcName">
                  <el-input v-model="form.appcName" style="width: 50%;" placeholder="请输入名称"></el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="demo-drawer__footer" style="margin-top: 10px;">
            <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
            <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
              确 定</el-button>
          </div>
        </el-drawer>
      </div>
    </div>
  </template>
    
  <script>
  
  import { getAjPurchasePayChannelList, addAjPurchasePayChannel, updateAjPurchasePayChannel, deleteAjPurchasePayChannel } from "../../api/api";
  export default {
    name: "",
    components: {},
    data() {
      return {
        key: 'appcId',
        dialog: false,
        edit: false,
        form: {
          appcName: '',
        },
        rules: {},
        // 未编辑前的值
        lastValue: "",
        // 单元格编辑功能
        editOption: {
          beforeCellValueChange: ({ row, column, changeValue }) => {
            this.beforeCellValChange(row, column, changeValue);
          },
          afterCellValueChange: ({ row, column, changeValue }) => {
            this.afterCellValChange(row, column, changeValue);
          },
        },
        cellSelectionOption: {
          // disble cell selection
          enable: true,
        },
        totalCount: 100,
        pageIndex: 1,
        pageSize: 20,
        selectedRowKeysCollection: [],
        checkboxOption: {
          // 可控属性
          selectedRowKeys: [],
          // 行选择改变事件
          selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
            this.changeSelectedRowKeys(row, isSelected, this.key);
          },
          // 全选改变事件
          selectedAllChange: ({ isSelected, selectedRowKeys }) => {
            this.changeSelectAll(isSelected, selectedRowKeys, this.key);
          },
        },
        cellStyleOption: {
          headerCellClass: ({ column, rowIndex }) => {
            if (rowIndex === 0) {
              return "table-header-cell-class";
            }
          },
        },
        windheight: "",
        tableHight: 520,
        columns: [
          {
            field: "",
            key: "checkbox",
            // type=checkbox
            type: "checkbox",
  
            title: "",
            width: 50,
            align: "center",
          },
          {
            field: "",
            key: "a",
            title: "序号",
            width: 50,
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return ++rowIndex;
            },
          },
          {
            field: "appcName",
            key: "b",
            title: "类型",
            align: "center",
            edit: true,
          },
          { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
          {
            field: "",
            key: "d",
            title: "操作",
            width: 200,
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span>
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.handleEdit(row)}
                  >
                    编辑
                  </el-button>
                  <el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.handleDelete(row)}
                  >
                    删除
                  </el-button>
                </span>
              );
            },
          },
        ], //表格的列
        tableData: [],
        post: null,
        formDatas: {
          dmDelete: 1,
          currentPage: 1,
          pageSize: 20,
        },
      };
    },
    activated() {
      this.watchFlag = true;
      this.$nextTick(() => {
        this.windheight = this.$store.state.windheight;
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
      });
    },
    watch: {
      "$store.state.windheight"(val) {
        this.$nextTick(() => {
          if (this.watchFlag) {
            this.tableHight = val - 200 - val * 0.04;
          }
        });
      },
    },
    deactivated() {
      this.watchFlag = false;
    },
    created() {
      this.windheight = this.$store.state.windheight
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
      this.getList();
    },
    mounted() { },
    methods: {
      // 批量删除
      BulkDelete() {
        if (this.selectedRowKeysCollection.length == 0) {
          this.$message({
            showClose: true,
            message: "请选择",
            type: 'danger'
          });
        } else if (this.selectedRowKeysCollection.length > 0) {
          this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              deleteAjPurchasePayChannel({ appcIds: this.selectedRowKeysCollection.toString() }).then(res => {
                if (res.data) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
  
                  this.partserch()
                }
              })
            }).catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            })
        }
      },
      handleDelete(row) {
        this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
  
            deleteAjPurchasePayChannel({ appcIds: row.appcId }).then(res => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
  
                this.partserch()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      },
      handleEdit(row) {
        const data = JSON.parse(JSON.stringify(row))
        this.dialog = true;
        this.edit = true;
        this.$nextTick(() => {
          this.form = data;
        })
      },
      SureBtn() {
        if (!this.edit) {
          this.$confirm("是否确定要新增, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              addAjPurchasePayChannel(this.form).then(res => {
                if (res.data) {
                  this.$message({
                    type: "success",
                    message: "新增成功!",
                  });
                  this.handleClose()
                  this.getList()
                }
              })
            }).catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            })
        } else {
          this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              updateAjPurchasePayChannel(this.form).then(res => {
                if (res.data) {
                  this.$message({
                    type: "success",
                    message: "编辑成功!",
                  });
                  this.handleClose()
                  this.getList()
                }
              })
            }).catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            })
        }
  
      },
      BoxOpen() {
        this.dialog = true;
  
      },
      // 关闭弹框
      handleClose() {
        this.dialog = false;
        this.edit = false;
        this.$refs['formRef'].resetFields();
      },
      // 修改单元格
      async beforeCellValChange(row, column, changeValue) {
        if (row[column.field] == changeValue) {
          return false;
        }
  
        this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var jsonObj = {};
            let formData = new FormData();
            formData.append(column.field, changeValue);
            formData.forEach((value, key) => (jsonObj[key] = value));
            jsonObj.appcId = row.appcId
            console.log(jsonObj);
            updateAjPurchasePayChannel(jsonObj).then(res => {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
            })
  
          })
          .catch(() => {
            this.lastValue = row[column.field];
            this.$nextTick(() => {
              this.tableData.forEach((item) => {
                for (let key in item) {
                  if (key == column.field && item[key] == changeValue) {
                    item[key] = this.lastValue;
                  }
                  console.log(key);
                }
              });
            });
            this.$message({
              type: "info",
              message: "已取消编辑",
            });
            return false;
          });
      },
      afterCellValChange(row, column, changeValue) {
        // console.log(" afterCellValChange", row, column, changeValue);
      },
      // reset selectedRowKeys
      resetSelectedRowKeys(key) {
  
        this.checkboxOption.selectedRowKeys = [];
  
        const selectedRowKeysCollection = this.selectedRowKeysCollection;
  
        if (selectedRowKeysCollection.length) {
          this.tableData.forEach((item) => {
            if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
              console.log(item);
              this.checkboxOption.selectedRowKeys.push(item[key]);
            }
          });
        }
      },
      // select all change
      changeSelectAll(isSelected, selectedRowKeys, key) {
  
        this.checkboxOption.selectedRowKeys = selectedRowKeys;
  
        if (isSelected) {
          this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
        } else {
          this.tableData.forEach((item, index) => {
            if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
              this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
            }
          });
        }
      },
      changeSelectedRowKeys(row, isSelected, key) {
  
        const rowKey = row[key];
  
        if (isSelected) {
          this.checkboxOption.selectedRowKeys.push(rowKey);
          this.selectedRowKeysCollection.push(rowKey);
          console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
        } else {
          const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
          this.checkboxOption.selectedRowKeys.splice(index, 1);
          this.selectedRowKeysCollection.splice(index, 1);
        }
      },
      pageSizeChange(pageSize) {
  
        this.formDatas.pageSize = pageSize;
        this.partserch();
  
  
      },
      pageNumberChange(pageIndex) {
        console.log(pageIndex);
        this.formDatas.currentPage = pageIndex;
        getAjPurchasePayChannelList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
          this.resetSelectedRowKeys(this.key);
          // this.$message({
          //   type: "success",
          //   message: "搜索成功!",
          // });
        });
  
      },
      partserch() {
        this.formDatas.currentPage = 1;
        getAjPurchasePayChannelList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
          this.resetSelectedRowKeys(this.key);
          // this.$message({
          //   type: "success",
          //   message: "搜索成功!",
          // });
        });
      },
      getList() {
        getAjPurchasePayChannelList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
        });
      },
    },
  };
  </script>
    
  <style>
  .table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
  }
  
  .easetable::-webkit-scrollbar {
    display: none;
  }
  
  .ve-table-container {
    height: auto !important;
  }
  </style>
    